import React, { useState } from 'react';
import { Row, Col, ButtonGroup, Button, Form, Label, Input, FormGroup } from 'reactstrap';
import FormInput from '../common/FormInput';

const dimensionFields = [
  { id: 'height', label: 'Height (cm)' },
  { id: 'width', label: 'Width (cm)' },
  { id: 'length', label: 'Length (cm)' },
  { id: 'grossWeight', label: 'Gross Weight (gm)' },
  { id: 'netWeight', label: 'Net Weight (gm)' },
  { id: 'liquid', label: 'Liquid (ml)' },
  { id: 'cubic', label: 'Cubic (cm)' },
];

const ExtendedDetailsTab = () => {
  const [dimensions, setDimensions] = useState({
    height: '',
    width: '',
    length: '',
    grossWeight: '',
    netWeight: '',
    liquid: '',
    cubic: '',
  });
  const [dangerousGoods, setDangerousGoods] = useState(false);

  const handleDimensionChange = (field: string, value: string) => {
    setDimensions(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="page-content p-0">
      <Row className="mb-3">
        <Col>
          <ButtonGroup className="gap-2">
            <button className="d-inline-flex align-items-center btn btn-soft-success btn-sm">
              <i className="ri-save-line align-middle me-1"></i> Save
            </button>
            <button className="d-inline-flex align-items-center btn btn-soft-warning btn-sm">
              <i className="ri-close-line align-middle me-1"></i> Cancel
            </button>
          </ButtonGroup>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <fieldset className="border p-2">
            <legend className="float-none w-auto px-2 mb-0" style={{ fontSize: '1rem' }}>Dimensions</legend>
            <Form>
              {dimensionFields.map(({ id, label }, idx) => (
                <FormInput
                  key={id}
                  id={id}
                  label={label}
                  value={dimensions[id as keyof typeof dimensions]}
                  onChange={val => handleDimensionChange(id, val)}
                  type="number"
                  className={idx !== dimensionFields.length - 1 ? 'mb-2' : ''}
                />
              ))}
            </Form>
          </fieldset>
        </Col>
        <Col md={3}>
          <fieldset className="border p-2">
            <legend className="float-none w-auto px-2 mb-0" style={{ fontSize: '1rem' }}>Details</legend>
            <FormGroup check className="d-flex align-items-center mt-2">
              <Input
                type="checkbox"
                id="dangerousGoods"
                checked={dangerousGoods}
                onChange={() => setDangerousGoods(d => !d)}
                bsSize="sm"
              />
              <Label for="dangerousGoods" className="mb-0 ms-2">Dangerous Goods</Label>
            </FormGroup>
          </fieldset>
        </Col>
      </Row>
    </div>
  );
};

export default ExtendedDetailsTab; 